import { combineReducers } from "redux";
import { companyUsersReducer } from "src/modules/companies/redux";
import { notificationReducer } from "src/modules/notification/redux";
import { emailLogsReducer } from "src/modules/email-log/redux/email-log.slice";
import { companyDashboardReducer } from "src/modules/company-dashboard/redux";
import { alertsReducer } from "../redux/alerts/alerts.slice";
import { loadingReducer } from "../redux/loading/loading.slice";
import { constantsReducer } from "../redux/constants/constants.slice";
import { sessionReducer } from "../redux/session/session.slice";
import { approvalsReducer } from "../../modules/approvals/redux/slice";
import { companiesReducer } from "../../modules/companies/redux/slice";
import scanTrackSummaryReducer from "../../modules/data-summary/redux/scan-track-summary-data/scan-track-summary-data.slice";
import { snSummaryReducer } from "../../modules/data-summary/redux/serial-number-summary";
import {
  disbursementReducer,
  transactionReportsReducer,
} from "../../modules/consumer-engagement/redux";
import { partnersAndResellersReducer } from "../../modules/partners-and-resellers/redux/partners-and-resellers.slice";
import { dashboardReducer } from "../../modules/dashboard/redux/slice/dashboard.slice";
import { masterControlReducer } from "../../modules/master-control/redux/master-control.slice";
import { bundlesReducer } from "../../modules/bundles/redux/bundles.slice";
import { dataSummaryReducer } from "../../modules/data-summary/redux/qr-credit-summary/data-summary.slice";
import { stockoutSummaryReducer } from "../../modules/data-summary/redux/stockout-number-summary";
import {
  supportReducer,
  supportNotificationsReducer,
} from "../../modules/support/redux/slice";
import { managementSnReducer } from "../../modules/management-sn/redux/slice";

const rootReducer = combineReducers({
  alerts: alertsReducer,
  loading: loadingReducer,
  constants: constantsReducer,
  session: sessionReducer,
  approvals: approvalsReducer,
  companies: companiesReducer,
  companyDashboard: companyDashboardReducer,
  disbursement: disbursementReducer,
  companyUsers: companyUsersReducer,
  partnersAndResellers: partnersAndResellersReducer,
  dashboard: dashboardReducer,
  notification: notificationReducer,
  emailLog: emailLogsReducer,
  masterControl: masterControlReducer,
  dataSummary: dataSummaryReducer,
  transactionReport: transactionReportsReducer,
  bundles: bundlesReducer,
  scanTrackSummary: scanTrackSummaryReducer,
  snSummary: snSummaryReducer,
  stockoutSummary: stockoutSummaryReducer,
  support: supportReducer,
  supportNotifications: supportNotificationsReducer,
  managementSn: managementSnReducer,
});

export default rootReducer;
